import React from 'react';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './FaqButton.module.scss';

const FaqButton = ({ tag, onClick, active }) => (
  <div
    className={cn({
      [CN.component]: true,
      [CN.isActive]: active,
    })}
    data-bem="FaqButton"
    data-tag={fromAnyToTrimmed(tag)}
    role="button"
    tabIndex={0}
    onClick={onClick}
  >
    <div className={CN.button}>
      <Icon variant="slickMonogram" selected width="md" />
      <span className={CN.text}>FAQs</span>
    </div>
  </div>
);

export default FaqButton;
